import { action, computed, makeObservable, observable } from 'mobx';

import { IApiClient } from '../../app/data/client';
import * as model from '../../app/data/model';
import type { ShoppingCartItemGroupData } from '../../app/data/model';
import ModularConfiguratorState from '../../app/modularConfigurator/components/ModularConfiguratorCoordinator/ModularConfigurator/ModularConfiguratorState';
import ModularConfiguratorCoordinatorState from '../../app/modularConfigurator/components/ModularConfiguratorCoordinator/ModularConfiguratorCoordinatorState';
import { AsyncCommand } from '../../app/shared/common';
import { IEventAggregator } from '../../app/shared/EventAggregator';
import { INavigationService } from '../../app/shared/NavigationService';
import { StoreState } from '../../app/StoreState';
import { ShoppingCartUpdatedEvent } from '../cart/events/ShoppingCartUpdatedEvent';
import { AddedToCartModalState } from '../configurator/AddedToCartModal/AddedToCartModalState';
import type { CartActionType } from '../configurator/ConfiguratorActionsState';
import { ConfigurationActionsTranslation } from '../localization/SiteTranslation';

export class ModularConfiguratorActionsState {
  @observable.ref
  public recentlyAddedItemModal: AddedToCartModalState<ShoppingCartItemGroupData>;

  public addToCartCommand: AsyncCommand;

  public configurator: ModularConfiguratorState;

  // public updateCartItemCommand: AsyncCommand;

  constructor(
    public readonly state: ModularConfiguratorCoordinatorState,
    public readonly store: StoreState,
    private readonly client: IApiClient,
    private readonly navigation: INavigationService,
    private readonly eventAggregator: IEventAggregator,
    public readonly translation: ConfigurationActionsTranslation,
  ) {
    makeObservable(this);
    this.recentlyAddedItemModal = new AddedToCartModalState(this.navigation, this.translation.addedToCartModal);

    this.addToCartCommand = new AsyncCommand(this.addModularProductToDealerCart);
    this.configurator = state.configurator;
    // this.updateCartItemCommand = new AsyncCommand(this.updateModularProductInDealerCart);
  }

  @computed
  public get cartActionType(): CartActionType {
    // return this.configurator.shoppingCartItemId ? 'Update' : 'Add';
    return 'Add';
  }

  private addModularProductToDealerCart = async () => {
    const command = new model.AddModularProductToDealerCartCommand({
      shoppingContext: this.store.shoppingContext,
      modularCode: this.configurator.summary.configurationCode,
      name: `${this.state.productFamilyName} - ${this.state.layoutPicker.active.data.name}`,
      configuration: this.configurator.getConfigurationData(),
      products: this.configurator.usedComponentConfigurationsCounter.map((component) =>
        component.configuration.coreState.getProductConfiguration(component.quantity),
      ),
    });

    const response = await this.client.send(command);

    // const priceToTrack = response.recentItem.salePriceWithTax.amount;
    // Analytics.trackAddToCart(this.configurator.buildAddToCartEvent(priceToTrack));

    this.openRecentItemModal(response.recentGroup, response.quantityAdded);

    this.eventAggregator.publish(new ShoppingCartUpdatedEvent(response.dealerCarts.cartsSummary));
  };

  private updateModularProductInDealerCart = async () => {
    // const command = new UpdateProductConfigurationInDealerCartCommand({
    //   lineItemId: this.configurator.shoppingCartItemId,
    //   productConfiguration: this.configurator.getProductConfiguration(false),
    //   shoppingContext: this.store.shoppingContext,
    // });
    // const response = await this.client.send(command);
    // this.openRecentItemModal(response.updatedItem, response.updatedItem.quantity);
    // this.eventAggregator.publish(new ShoppingCartUpdatedEvent(response.dealerCarts.cartsSummary));
  };

  @action.bound
  private openRecentItemModal(lastItem: ShoppingCartItemGroupData, lastItemAddedQuantity: number) {
    this.recentlyAddedItemModal.setRecentlyAddedItem(lastItem, lastItemAddedQuantity);
    this.recentlyAddedItemModal.open();
  }
}
